import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {MatDialogModule} from '@angular/material/dialog';
import {MatButtonModule} from '@angular/material/button';

import { DashboardRoutingModule } from './dashboard-routing.module';
import { AnnouncementsComponent } from './announcements/announcements.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { EmployeeProfileComponent } from '../employee-profile/employee-profile.component';
import { LearnNextComponent } from './learn-next/learn-next.component';
import { LearningsComponent } from './learnings/learnings.component';
import { ProfileCardComponent, ProfileCardDialog } from './profile-card/profile-card.component';
import { ProfileViewComponent } from './profile-view/profile-view.component';
import { SharedModule } from '../shared/shared.module';
import { FormsModule } from '@angular/forms';
import { EmployeeDetailsComponent, TooltipListPipe } from '../employee-details/employee-details.component';
import { MatTabsModule } from "@angular/material/tabs";
import { MatButtonToggleModule } from '@angular/material/button-toggle';

import { CarouselModule } from 'primeng/carousel';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import { ChartModule } from 'primeng/chart';
import { TeamLearningsComponent } from './team-learnings/team-learnings.component';
import { TeamProgressComponent } from './team-progress/team-progress.component';
import { TeamProgramComponent } from './team-program/team-program.component';
import { EcpSharedModule } from '../employee/shared/ecp-shared.module';
@NgModule({
  declarations: [
    AnnouncementsComponent,
    DashboardComponent,
    EmployeeProfileComponent,
    LearnNextComponent,
    LearningsComponent,
    ProfileCardComponent,
    ProfileViewComponent,
    EmployeeDetailsComponent,
    TooltipListPipe,
    ProfileCardDialog,
    TeamLearningsComponent,
    TeamProgressComponent,
    TeamProgramComponent
  ],
  imports: [
    CommonModule,
    MatTabsModule,
    MatButtonToggleModule,
    DashboardRoutingModule,
    FormsModule,
    MatButtonModule,
    MatDialogModule,
    SharedModule,
    CarouselModule,
    MatProgressBarModule,
    ChartModule,
    EcpSharedModule
  ]
})
export class DashboardModule { }
